module.exports = require("./su-Latn.d.ts");